'use client';
import { lazy, Suspense, type ComponentProps } from 'react';
export type * from "/tmp/build-379/node_modules/@eliadmin/core/src/pages/(profile)/watchdogs/page.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-379/node_modules/@eliadmin/core/src/pages/(profile)/watchdogs/page.tsx").default>>;
const Deferred = lazy(() => import("@eliadmin/route-original/e1f68cf523ea"));
function DeferredRoute(props: Props) { return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
export default DeferredRoute;

